/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Computer_Science21Inputs */

const en__field__enum_studyprograms_study_computer_science21 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Computer_Science21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de__field__enum_studyprograms_study_computer_science21 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Computer_Science21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {_Field__Enum_Studyprograms_Study_Computer_Science21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_computer_science21 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Computer_Science21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Computer_Science21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_computer_science21(inputs)
	return de__field__enum_studyprograms_study_computer_science21(inputs)
});
export { _field__enum_studyprograms_study_computer_science21 as "_field__enum_studyPrograms_STUDY_COMPUTER_SCIENCE" }